import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { GridContainerDirective, GridItemDirective } from './grid-layout';
import { LoaderButtonDirective } from './loader-button.directive';
import { LoaderOutletComponent } from './loader-outlet/loader-outlet.component';
import { LoaderOutletDirective } from './loader-outlet/loader-outlet.directive';
import { NotFoundComponent } from './not-found/not-found.component';
import { RootLoaderOutletComponent } from './root-loader-outlet/root-loader-outlet.component';
import { SubtleLoaderOutletComponent } from './subtle-loader-outlet/subtle-loader-outlet.component';



@NgModule({
  declarations: [
    NotFoundComponent,
    LoaderOutletComponent,
    SubtleLoaderOutletComponent,
    RootLoaderOutletComponent,
    LoaderButtonDirective,
    LoaderOutletDirective,
    GridItemDirective,
    GridContainerDirective
  ],
  exports: [
    NotFoundComponent,
    LoaderOutletComponent,
    SubtleLoaderOutletComponent,
    RootLoaderOutletComponent,
    LoaderButtonDirective,
    GridItemDirective,
    LoaderOutletDirective,
    GridContainerDirective
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule
  ]
})
export class SharedComponentsModule { }
